// Function to match behavior as described here: https://help.okta.com/en-us/content/topics/security/policies/about-password-policies.htm#:~:text=Does%20not%20contain%20part%20of,john%2C%20smith%2C%20or%20okta.
// "Does not contain part of username: this requirement rejects any password that contains parts of the login ID based on the delimiters (., ,, -, _, #, and @).
// For example, if the login ID is john.smith@okta.com, selecting this option rejects any password that contains john, smith, or okta."
const passwordIncludesUsername = (password: string, username: string) => {
  // TODO: Commented lines below includes the logic to split the username by the delimiters and check if any of the individual parts include the password
  // Since username requirements do not allow any of these delimiter characters, we can just check the username as a whole for now
  // Use the delimiter logic once we can include proper unit tests to go with it
  // const usernameParts = username.split(/[.,\-_#@]+/)
  // return usernameParts.some((part) => {
  //   return password.toLowerCase().includes(part.toLowerCase());
  // });

  return password.toLowerCase().includes(username.toLowerCase());
};

export default passwordIncludesUsername;
